// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wcdy","title":"Info_title__1xcnQ","links":"Info_links__Bsly4","link":"Info_link__3Fwsj","logo":"Info_logo__2mpiu"};